import { useTranslations } from 'next-intl';
import { CatHeading } from 'components/blocks-components';

const EquipmentTitle = () => {
  const t = useTranslations();

  return (
    <CatHeading variant="title">
      {t('PDP_PARTSDIAGRAM_ADD_EQ_HEADING')}
    </CatHeading>
  );
};

export default EquipmentTitle;
